import request from '@/utils/request'


/**
 * 登录场景
 * @param {Object} data 
 * @returns 
 */
export function login (data) {
    return request({
        url: '/user/login',
        method: 'POST',
        data
    })
}


/**
 * 登出场景
 * @param {Object} data 
 * @returns 
 */
export function logout (data) {
    return request({
        url: '/user/logout',
        method: 'POST',
        data
    })
}

/**
 * 删除用户
 * @param {Object} data 
 * @returns 
 */
export function userDelete (data) {
    return request({
        url: '/user',
        method: 'delete',
        data
    })
}

export function listAction (data) {
    return request({
        url: '/admin/business/action/list',
        method: 'POST',
        data,
    })
}
export function addAction (data) {
    return request({
        url: '/admin/business/action/add',
        method: 'POST',
        data,
    })
}
export function updateAction (data) {
    return request({
        url: '/admin/business/action/update',
        method: 'PUT',
        data,
    })
}
/**
 * 用户恢复
 * @param {Object} data 
 * @returns 
 */
export function userRecover (data) {
    return request({
        url: '/user/recover',
        method: 'POST',
        data
    })
}

/**
 * 用户锁定
 * @param {Object} data 
 * @returns 
 */
export function userLock (data) {
    return request({
        url: '/user/lock',
        method: 'POST',
        data
    })
}

/**
 * 用户解除锁定
 * @param {Object} data 
 * @returns 
 */
export function userUnlock (data) {
    return request({
        url: '/user/unlock',
        method: 'POST',
        data
    })
}

/**
 * 用户列表
 * @param {Object} data 
 * @returns 
 */
export function userList (data) {
    return request({
        url: '/user/list',
        method: 'POST',
        data
    })
}

/**
 * 重置密码
 * @param {Object} data 
 * @returns 
 */
export function resetpassword (data) {
    return request({
        url: '/user/resetpassword',
        method: 'POST',
        data
    })
}

/**
 * 更新用户信息
 * @param {Object} data 
 * @returns 
 */
export function userUpdate (data) {
    return request({
        url: '/user/update',
        method: 'put',
        data
    })
}
/**
 * 注册
 * @param {Object} data 
 * @returns 
 */
export function register (data) {
    return request({
        url: '/user/register',
        method: 'POST',
        data
    })
}
/**
 * 上传
 * @param {Object} data 
 * @returns 
 */
import Oss from 'ali-oss';

export function ossUpload({ path, file}) {
    return new Promise((resolve, reject) => {
        request({
            url: '/ali/getStsToken',
            method: 'get'
        }).then(res => {
            const creditInfo = res.data;
            const aliOss = new Oss(creditInfo);
            aliOss.put(`${path}/${new Date().getTime()}/${file.name}`, file, {
                headers: {
                    'Access-Control-Allow-Origin': '*'
                }
            }).then(uploadRes => {
                resolve(uploadRes);
            })
        })
        .catch(
            reject
        )
    })
}

export function getossUploadToken() {
  return  request({
      url: '/ali/getStsToken',
      method: 'get',
    })
}

export function upload (data) {
    return request({
        headers: {
            'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq',
        },
        url: '/upload',
        method: 'POST',
        data
    })
}

/**
 * 获取用户信息
 * @param {Object} params 
 * @returns 
 */
export function userInfo (params) {
    return request({
        url: '/user/info',
        method: 'GET',
        params
    })
}

/**
 * 专业列表
 * @param {Object} params 
 * @returns 
 */
export function professionList (params) {
    return request({
        url: '/profession/list',
        method: 'GET',
        params
    })
}
/**
 * 组列表
 * @param {Object} params 
 * @returns 
 */
export function groupList (params) {
    return request({
        url: '/group/list',
        method: 'GET',
        params
    })
}
/**
 * 区域列表
 * @param {Object} params 
 * @returns 
 */
export function areaList (params) {
    return request({
        url: '/area/list',
        method: 'GET',
        params
    })
}

/**
 * 专业列表
 * @param {Object} params 
 * @returns 
 */
export function majorList (params) {
    return request({
        url: '/major/list',
        method: 'GET',
        params
    })
}
/**
 * 行业列表
 * @param {Object} params 
 * @returns 
 */
export function industryList (params) {
    return request({
        url: '/industry/list',
        method: 'GET',
        params
    })
}
/**
 * 元列表
 * @param {Object} params 
 * @returns 
 */
export function metaList (params) {
    return request({
        url: '/metacategory/list',
        method: 'GET',
        params
    })
}
/**
 * 状态列表
 * @param {Object} params 
 * @returns 
 */
export function statusList (params) {
    return request({
        url: '/status/list',
        method: 'GET',
        params
    })
}
export function removeRole (data) {
    return request({
        url: '/admin/system/role/delete',
        method: 'DELETE',
        data,
    })
}
/**
 * 作用列表
 * @param {Object} params 
 * @returns 
 */
export function functionList (params) {
    return request({
        url: '/function/list',
        method: 'GET',
        params
    })
}

/**
 * 模型分类列表
 * @param {Object} params 
 * @returns 
 */
export function categoryList (data) {
    return request({
        url: '/lib/category/list',
        method: 'POST',
        data
    })
}


/**
 * 模型分类列表
 * @param {Object} params 
 * @returns 
 */
export function setUserInformation (data) {
    return request({
        url: '/userDataStatistics/setUserLoginTime',
        method: 'POST',
        data
    })
}


// /**
//  * 帧名称列表
//  * @param {Object} params 
//  * @returns 
//  */
// export function getAnimationName (data) {
//     return request({
//         url: '/lib/category/getAnimationName',
//         method: 'POST',
//         data
//     })
// }